import { render } from "./Topup2c2p.vue?vue&type=template&id=58a22cf1&scoped=true"
import script from "./Topup2c2p.vue?vue&type=script&lang=js"
export * from "./Topup2c2p.vue?vue&type=script&lang=js"

import exportComponent from "H:\\git\\Net_Web_LandingVue\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58a22cf1"]])

export default __exports__